var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",function(){return [(!_vm.noText)?_c('span',[_vm._v("Loading...")]):_vm._e()]}),_c('BSpinner')],2)}
var staticRenderFns = []

export { render, staticRenderFns }